// Requires the `stats_data` path in RESOLVE_RELATIONS to inline the story.

import type { SbBlokData } from "@storyblok/react/rsc";

export type Stat = SbBlokData & {
  value?: string;
  label?: string;
  description?: string;
  key?: string;
};

export type StatsRef = string | { content?: { stats?: Stat[] } } | null | undefined;

// The picked story wins, so a page cannot drift from the shared set.
export function statsFrom(ref: StatsRef, local?: Stat[]): Stat[] {
  const shared = ref && typeof ref === "object" ? ref.content?.stats : undefined;
  return shared?.length ? shared : (local ?? []);
}

export function statByKey(ref: StatsRef, key?: string): Stat | undefined {
  if (!key) return undefined;
  return statsFrom(ref).find((stat) => stat.key === key);
}
